import { createSafeContext } from 'core/Utils';
import { PurchasesSearch } from 'store/Api';

type UserPurchasesSearchContextValue = {
  UserPurchasesSearchObject: PurchasesSearch | undefined;
  setUserPurchasesSearchObject(value: PurchasesSearch): void;
};

export const [UserPurchasesSearchProvider, useUserPurchasesSearchContext] =
  createSafeContext<UserPurchasesSearchContextValue>(
    'User purchase component was not found in tree'
  );
